'use strict';
import sanitizer 		from './helpers/sanitizer';
import formater 		from './helpers/formater';

import {API_CACHETIME} 	from './config';


import Vue from 'vue'


import forEach 			from 'lodash/forEach';
import concat 			from 'lodash/concat';
import isEmpty 			from 'lodash/isEmpty';
import sortedIndexBy 	from 'lodash/sortedIndexBy';
import { forIn } from 'lodash';

var cache = {};

function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
	var R = 6371; // Radius of the earth in km
	var dLat = deg2rad(lat2-lat1);  // deg2rad below
	var dLon = deg2rad(lon2-lon1);
	var a =
		Math.sin(dLat/2) * Math.sin(dLat/2) +
		Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
		Math.sin(dLon/2) * Math.sin(dLon/2);
	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
	var d = R * c; // Distance in km
	return d;
}

function deg2rad(deg) {
	return deg * (Math.PI/180)
}

export default {
	/**
	 * ##################################################
	 * 						CUSTOMER
	 * ##################################################
	 */
	LOGIN_CUSTOMER({dispatch, rootGetters,getters, commit}, payload) {
		var $vm = this._vm,
			currentTime = new Date().getTime();

		console.debug('ORM|A|LOGIN_CUSTOMER');
		console.warn('ORM|A|LOGIN_CUSTOMER @todo land ist noch Statisch!');
		let form = new FormData();
		form.set('email', payload.email);
		form.set('password', payload.password);

		return $vm.$api
			.post('/api/customer/login', form)
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				commit("LOGIN_CUSTOMER", response.data.result.session_id)
				commit('reservation/SET_USER_SESSION', response.data.result.session_id);

				return (response.data.success ? response.data.result : Promise.reject(new Error('Cant login')));

			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	LOGOUT_CUSTOMER({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm;

		console.debug('ORM|A|LOGOUT_CUSTOMER');

		return $vm.$api
			.post('/api/customer/logout', {
				sid: getters['reservation/user_session']
			})
			.then(response => {
				commit("LOGOUT_CUSTOMER")
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				return (response.data.success ? response.data : Promise.reject(new Error('Cant login')));
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	RESET_CUSTOMER_PASSWORD({dispatch, rootGetters,getters, commit}, payload) {
		var $vm = this._vm;

		let form = new FormData();
		form.set('email', payload.email);

		return $vm.$api
		.put('/api/customer/reset_password', null,  {
				data: {email: payload.email, url: 'undefined'},
			})
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;

				return (response.data.success ? response.data.result : Promise.reject(new Error('Cant change custoumer data')));

			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},
	
	CHECK_CUSTOMER_EMAIL({dispatch, rootGetters,getters, commit}, payload) {
		var $vm = this._vm;
		return $vm.$api
			.get('/api/customer/email/check', {
				params: {
					email: payload.email
				}
			})
			.then(response => {
				return response.data;
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	CHECK_VOUCHER({dispatch, rootGetters,getters, commit}, payload) {
		var $vm = this._vm;
		//console.log(payload);
		return $vm.$api
			.get('/api/voucher/valid', {
				params: {
					code: payload.code,
					type: payload.type
				}
			})
			.then(response => {
				
				return response.data;
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	GET_CUSTOMER({dispatch, rootGetters,getters, commit}, sid) {
		var $vm = this._vm;

		console.debug('ORM|A|GET_CUSTOMER');
		return $vm.$api
			.get('/api/customer', {
				params: {
					sid: sid || getters['reservation/user_session']
				}
			})
			.then(response => {
				return response.data;
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	GET_CUSTOMER_RESERVATION({dispatch, rootGetters,getters, commit}, sid) {
		var $vm = this._vm;

		console.debug('ORM|A|GET_CUSTOMER_RESERVATION');
		return $vm.$api
			.get('/api/reservations', {
				params: {
					sid: sid || getters['reservation/user_session']
				}
			})
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				return (response.data.success ? response.data : Promise.reject(new Error('Cant get resetvations')));
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	CREATE_CUSTOMER({dispatch, rootGetters,getters, commit}, payload) {
		var $vm = this._vm, currentTime = new Date().getTime();

		console.debug('ORM|A|CREATE_CUSTOMER');
		if(typeof payload.email != 'string') return false;
		if(payload.email.length < 4) return false;

		/* name roundtrip cause  cx9*/

    	let formData = new FormData()

		for (var item in payload) {
		  formData.append(item, payload[item]);
		}

		return $vm.$api
			.post('/api/customer', formData)
			.then(response => {
				console.warn('ORM|A|CREATE_CUSTOMER @todo error message noch statisch!');
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				return (response.data.success ? response.data : Promise.reject(new Error('Cant register')));
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	

	CHANGE_CUSTOMER_DATA({dispatch, rootGetters, getters, commit}, customer) {
		var $vm = this._vm;

		customer.sid = getters['reservation/user_session'];

		return $vm.$api
		.put('/api/customer', null,  {
				params: {
					sid: getters['reservation/user_session']
				},
				data: customer
			})
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				console.log(response);
				return response.data.result;

				/// interim fix til cx9 prove it (response.data.success ? response.data.result : Promise.reject(new Error('Cant change custoumer data')));

			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	CHANGE_CUSTOMER_PASSWORD({dispatch, rootGetters, getters, commit}, password) {
		var $vm = this._vm;

		return $vm.$api
		.put('/api/customer/update_password', null,  {
				params: {
					sid: getters['reservation/user_session'],
					password: password
				},
				data: null
			})
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				console.log(response);
				return response.data.result;

				/// interim fix til cx9 prove it (response.data.success ? response.data.result : Promise.reject(new Error('Cant change custoumer data')));

			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	DELETE_CUSTOMER({dispatch, rootGetters, getters, commit}, customer) {
		var $vm = this._vm;

		let form = new FormData();
		let $sid = getters['reservation/user_session'];

		form.set('sid', getters['reservation/user_session']);	

		return $vm.$api
		.delete('/api/customer', {params: {sid: $sid, email: customer.email, id: customer.id}, data: {email: customer.email, id: customer.id, sid: $sid}})
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;

				return (response.data.success ? response.data.result : Promise.reject(new Error('Cant DELETE_CUSTOMER')));

			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},


	/*
	* ##################################################
	*					CONCARDIS PAYMENT
	* ##################################################
	*/

	CREATE_CONCARDIS_CUSTOMER({dispatch, rootGetters,getters, commit}, payload) {
		var $vm = this._vm, currentTime = new Date().getTime();

		console.debug('ORM|A|CREATE_CONCARDIS_CUSTOMER');
		if(typeof payload.email != 'string') return false;
		if(payload.email.length < 4) return false;

		/* name roundtrip cause  cx9*/

    	let formData = new FormData()

		for (var item in payload) {
		  formData.append(item, payload[item]);
		}

		return $vm.$api
			.post('/concardis/customers', formData)
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				return response.data;
				//return (response.data.success ? response.data : Promise.reject(new Error('already exists')));
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},

	POST_PAYMENTINSTRUMENT({dispatch, rootGetters,getters, commit}, payload) {
		var $vm = this._vm;
		//var cleanpayload = payload;
		function clean(obj) {
			for (var propName in obj) { 
			  if (obj[propName] === null || obj[propName] === undefined) {
				delete obj[propName];
			  }
			}
		  }
		var cleanpayload = clean(payload);
		console.debug(cleanpayload);

		console.debug('ORM|A|GET_PAYMENTINSTRUMENTS');
		return $vm.$api
			.post('/concardis/payment-instruments', payload)
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				return response.data;
			})

	},

	DELETE_PAYMENTINSTRUMENT({dispatch, rootGetters,getters, commit}, payload) {
		var $vm = this._vm;

		console.debug('ORM|A|DELETE_PAYMENTINSTRUMENT');

		console.log(payload);

		var paymentInstrumentId = {

			"paymentInstrumentId": payload['payment_id']
		
		}

		console.log(paymentInstrumentId);

		return $vm.$api
			.delete('/concardis/payment-instruments/' + payload['payment_id'])
			.then(response => {
				return response;
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				
			})

	},

	POST_CUSTOMER_PAYMENTINSTRUMENT({dispatch, rootGetters,getters, commit}, payload ) {
		var $vm = this._vm;

		console.debug('ORM|A|POST_CUSTOMER_PAYMENTINSTRUMENT');

		console.log(payload);

		var paymentInstrumentId = {

			"paymentInstrumentId": payload['payment_id']
		
		}

		return $vm.$api
			.post('/concardis/customers/' + payload['payment_customer'] + '/payment-instruments', paymentInstrumentId )
			.then(response => {
				return response;
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				
			})

	},

	

	GET_PAYMENTINSTRUMENTS({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm;

		console.debug('ORM|A|GET_PAYMENTINSTRUMENTS');
		return $vm.$api
			.get('/concardis/payment-instruments')
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				return response.data;
			})

	},

	/**
	 * ##################################################
	 * 						STATIONS
	 * ##################################################
	 */
	GET_STATIONS({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm, currentTime = new Date().getTime();

		if(typeof cache['GET_STATIONS'] !== 'undefined' && cache['GET_STATIONS'] < API_CACHETIME + currentTime && !isEmpty(getters.stations)){
			console.debug('ORM|A|GET_STATIONS:cached');
			return getters.stations;
		}

		console.debug('ORM|A|GET_STATIONS');
		const payload = {allStations: 1};
		if(getters['reservation/user_session']) {
			payload.sid = getters['reservation/user_session'];
		}
		return $vm.$api
			.get('/api/stations', {
				params: payload
			})
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;

				var result = response.data.result;
				result = result.filter(station => station.carsharing_station != '0');
				result = result.filter(station => station.carsharing_station != null);
				commit('SET_STATIONS', result);
				cache['GET_STATIONS'] = currentTime
				return result;
			})

	},

	GET_STATIONS_BY_DISTANCE({dispatch, rootGetters,getters, commit}, center) {
		console.debug('ORM|A|GET_STATIONS_BY_DISTANCE');

		if(isEmpty(getters.stations)){
			return dispatch('GET_STATIONS')
			.then(stations => {
				return dispatch('GET_STATIONS_BY_DISTANCE', center);
			});
		}

		let stationList = {};
		forEach(getters.stations, (station) => {
			var distance = getDistanceFromLatLonInKm(center.lat, center.lng, station.position.lat, station.position.long);
			stationList[distance] = station;
		});
		stationList = sortedIndexBy(stationList, (o, i) => { return i;});

		return stationList;
	},

	GET_STATIONS_BY_CITY({dispatch, rootGetters,getters, commit}) {
		console.debug('ORM|A|GET_STATIONS_BY_CITY');
		if(isEmpty(getters.stations)){
			return dispatch('GET_STATIONS')
			.then(stations => {
				return dispatch('GET_STATIONS_BY_CITY');
			});
		}

		let stationList = {};
		forEach(getters.stations, (station) => {
			if(typeof stationList[station.city] === 'undefined') stationList[station.city] = [];
			stationList[station.city].push(station);
		});
		sortedIndexBy(stationList, (o, i) => { return i;});

		return stationList;
	},

	/**
	 * ##################################################
	 * 					  CAR / GROUPS
	 * ##################################################
	 */
	GET_GROUPS({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm, currentTime = new Date().getTime();

		if(typeof cache['GET_GROUPS'] !== 'undefined' && cache['GET_GROUPS'] < API_CACHETIME + currentTime && !isEmpty(getters.groups)){
			console.debug('ORM|A|GET_GROUPS:cached');
			return getters.groups;
		}

		console.debug('ORM|A|GET_GROUPS');
		return $vm.$api
			.get('/api/groups')
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				cache['GET_GROUPS'] = currentTime
				commit('SET_GROUPS', response.data.result)
				return this.groups;
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},


	/**
	 * GET_GROUPS_FROM_STATION returns groups by  values from vuex store orm/reservation/
	 */
	GET_GROUPS_FROM_STATION({dispatch, rootGetters,getters, commit}) {
		console.debug('ORM|A|GET_GROUPS_FROM_STATION');

		var $vm = this._vm,
			station = getters['reservation/startstation'],
			url = '/api/groups' + (station.station ? '/' + station.station : '');


		var payload = {
			stationKey: station.station,
			startDate: formater.API_DATE(getters['reservation/startdate']),
			endDate: formater.API_DATE(getters['reservation/enddate']),
		};

		if(getters['reservation/user_session']) {
			payload.sid = getters['reservation/user_session'];
		}

		return $vm.$api
			.get(url, {
				params: payload
			})
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				commit('SET_GROUPS', response.data.result)
				return response.data.result;
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});

	},

	/**
	startStationKey				string		true		Key of Startstation
	returnStationKey			string		false		Key of Endstation
	startDate					DateTime	true		Y-m-d H:i	Startdate
	endDate						DateTime	true		Y-m-d H:i	Enddate
	**/
	GET_AVAILABLE_GROUPS({dispatch, rootGetters,getters, commit}) {
		console.debug('ORM|A|GET_AVAILABLE_GROUPS');
		var $vm = this._vm;

		var payload = {
			stationKey: getters['reservation/startstation'].station,
			startStationKey: getters['reservation/startstation'].station,
			returnStationKey: getters['reservation/endstation'].station,
			startDate: formater.API_DATE(getters['reservation/startdate']),
			endDate: formater.API_DATE(getters['reservation/enddate']),
			priceList: getters['reservation/rentaltype'],
		};

		if(getters['reservation/user_session']) {
			payload.sid = getters['reservation/user_session'];
		}

		return $vm.$api
			.get('/api/carsharing/reservation', {
				params: payload
			})
			.then(response => {
				var e; if(e = $vm.$apiservice.getResponseError(response)) return e;
				return response.data.result;
			}).catch(err => {
				return $vm.$apiservice.processApiCatch(err)
			});
	},



	/**
	 * ##################################################
	 * 					    BASICS
	 * ##################################################
	 */
	GET_PARAMS({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm, currentTime = new Date().getTime();
		if(typeof cache['GET_PARAMS'] !== 'undefined' && cache['GET_PARAMS'] < API_CACHETIME + currentTime && !isEmpty(getters.params)){
			console.debug('ORM|A|GET_PARAMS:cached');
			return getters.params;
		}

		console.debug('ORM|A|GET_PARAMS');
		return $vm.$api
			.get('/api/params')
			.then(response => {
				commit('SET_PARAMS', response.data.result);
				cache['GET_PARAMS'] = currentTime
				return response.data.result;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},


	GET_SALUTATIONS({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm, currentTime = new Date().getTime();
		if(typeof cache['GET_SALUTATIONS'] !== 'undefined' && cache['GET_SALUTATIONS'] < API_CACHETIME + currentTime && !isEmpty(getters.salutations)){
			console.debug('ORM|A|GET_SALUTATIONS:cached');
			return getters.salutations;
		}

		console.debug('ORM|A|GET_SALUTATIONS');
		return $vm.$api
			.get('/api/salutations')
			.then(response => {
				commit('SET_SALUTATIONS', response.data.result);
				cache['GET_SALUTATIONS'] = currentTime
				return response.data.result;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},


	GET_TRANSLATIONS({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm, currentTime = new Date().getTime();
		if(typeof cache['GET_TRANSLATIONS'] !== 'undefined' && cache['GET_TRANSLATIONS'] < API_CACHETIME + currentTime && !isEmpty(getters.translations)){
			console.debug('ORM|A|GET_TRANSLATIONS:cached');
			return getters.translations;
		}

		console.debug('ORM|A|GET_TRANSLATIONS');
		return $vm.$api
			.get('/api/translations')
			.then(response => {
				commit('SET_TRANSLATIONS', response.data.result);
				cache['GET_TRANSLATIONS'] = currentTime
				return response.data.result;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},


	GET_CS_TRANSLATIONS({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm, currentTime = new Date().getTime();
		if(typeof cache['GET_CS_TRANSLATIONS'] !== 'undefined' && cache['GET_CS_TRANSLATIONS'] < API_CACHETIME + currentTime && !isEmpty(getters.cs_translations)){
			console.debug('ORM|A|GET_CS_TRANSLATIONS:cached');
			return getters.cs_translations;
		}

		console.debug('ORM|A|GET_CS_TRANSLATIONS');
		return $vm.$api
			.get('/api/cshare/translations')
			.then(response => {
				commit('SET_CS_TRANSLATIONS', response.data.result);
				cache['GET_CS_TRANSLATIONS'] = currentTime
				return response.data.result;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},

	LOAD_ORM({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm;
		return Promise.all([
			dispatch('GET_PARAMS'),
			dispatch('GET_SALUTATIONS'),
			dispatch('GET_TRANSLATIONS'),
			dispatch('GET_CS_TRANSLATIONS'),
			dispatch('GET_FOOTERNAVIGATION'),
			dispatch('GET_MAINNAVIGATION')
		]).catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},


	GET_CONFIG({dispatch, rootGetters,getters, commit}) {
		var $vm = this._vm, currentTime = new Date().getTime();
		if(typeof cache['GET_CONFIG'] !== 'undefined' && cache['GET_CONFIG'] < API_CACHETIME + currentTime && !isEmpty(getters.config)){
			console.debug('ORM|A|GET_CONFIG:cached');
			return getters.config;
		}

		console.debug('ORM|A|GET_CONFIG');
		return $vm.$api
			.get('/api/config')
			.then(response => {
				commit('SET_CONFIG', response.data.result);
				cache['GET_CONFIG'] = currentTime
				return response.data.result;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},

	GET_FOOTERNAVIGATION({dispatch, rootGetters, getters, commit}) {
		var $vm = this._vm;

		return $vm.$api
			.get('/api/grav/footernavigation')
			.then(response => {
				commit('SET_FOOTERNAVIGATION', response.data);
				return response.data;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},

	GET_MAINNAVIGATION({dispatch, rootGetters, getters, commit}) {
		var $vm = this._vm;

		return $vm.$api
			.get('/api/grav/mainnavigation')
			.then(response => {
				commit('SET_MAINNAVIGATION', response.data);
				return response.data;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},

	GET_HOMEPAGE({dispatch, rootGetters, getters, commit}) {
		var $vm = this._vm;

		return $vm.$api
			.get('/api/grav/home')
			.then(response => {
				commit('SET_HOMEPAGE', response.data);
				return response.data;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},
	GET_CONTACTPAGE({dispatch, rootGetters, getters, commit}) {
		var $vm = this._vm;

		return $vm.$api
			.get('/api/grav/contactpage')
			.then(response => {
				commit('SET_CONTACTPAGE', response.data);
				return response.data;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},
	GET_FAQ({dispatch, rootGetters, getters, commit}) {
		var $vm = this._vm;

		return $vm.$api
			.get('/api/grav/faq')
			.then(response => {
				commit('SET_FAQ', response.data);
				return response.data;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},
	GET_HEADERNAVIGATION({dispatch, rootGetters, getters, commit}) {
		var $vm = this._vm;

		return $vm.$api
			.get('/api/grav/headernavigation')
			.then(response => {
				commit('SET_HEADERNAVIGATION', response.data);
				return response.data;
			})
			.catch(err => { commit("core/ADD_ERROR", err, { root: true }); });
	},

};



// WEBPACK FOOTER //
// ./src/store/orm/actions.js